/**
 * Survey Template API Client
 * 問卷模板 API 客戶端
 */

import { getApiBase, getApiHeaders, getTenantIdFromUrl } from './apiUtils';

export interface SurveyTemplate {
  id: number;
  tenantId: string;
  title: string;
  description?: string;
  isActive: number;
  config: {
    // 舊結構（向後兼容）
    sections?: Array<{
      title: string;
      icon?: string;
      fields: Array<SurveyFieldConfig>;
    }>;
    // 新結構
    meta?: {
      title?: string;
      submitLabel?: string;
    };
    theme?: {
      primaryColor?: string;
      backgroundColor?: string;
      cardColor?: string;
      textColor?: string;
      fontStyle?: 'fun' | 'formal' | 'modern';
      emoji?: string;
    };
    fields?: Array<SurveyFieldConfig>;
  };
  createdAt?: string;
  updatedAt?: string;
}

export interface SurveyFieldConfig {
  id?: string; // 新格式使用 id
  name?: string; // 舊格式使用 name（向後兼容）
  type:
    | 'text'
    | 'phone'
    | 'email'
    | 'radio'
    | 'checkbox'
    | 'textarea'
    | 'select'
    | 'number'
    | 'rating';
  label: string;
  required: boolean;
  placeholder?: string;
  validation?: {
    pattern?: string;
    message?: string;
    min?: number;
    max?: number;
  };
  options?: Array<{ value: string; label: string }> | string[]; // rating 類型可能是字串陣列
  showOther?: boolean;
  rows?: number;
  maxLength?: number;
}

/**
 * 取得啟用的問卷模板
 */
export async function getActiveSurveyTemplate(): Promise<SurveyTemplate | null> {
  const apiBase = getApiBase();
  const tenantId = getTenantIdFromUrl();
  const headers = getApiHeaders(tenantId);

  const { apiFetch } = await import('./apiUtils.js');
  const response = await apiFetch(`${apiBase}/api/survey-templates/active`, {
    method: 'GET',
    headers,
  });

  if (!response.ok) {
    if (response.status === 404) {
      return null; // 沒有啟用的模板
    }
    throw new Error('取得問卷模板失敗');
  }

  const result = await response.json();
  if (result.success && result.data) {
    return result.data;
  }

  return null;
}
